import React, { useEffect, useState } from "react";
import { Button, Input, Select, Table } from "antd";
import "aos/dist/aos.css";
import "../../MainCSS.css";
import { Option } from "antd/es/mentions";
import axios from "axios";
import { toast } from "react-toastify";
import { GetCustomerMaster } from '../../../AllAPI/MasterAPI/SalesMasterApi';
import { SaveCustomerMaster } from '../../../AllAPI/MasterAPI/SalesMasterApi';
import { UpdateCustomerMaster } from '../../../AllAPI/MasterAPI/SalesMasterApi';
import { DeleteCustomerMaster } from '../../../AllAPI/MasterAPI/SalesMasterApi';

const CustomerMaster = () => {

  const storedHeaders = JSON.parse(sessionStorage.getItem('authHeaders')) || {};
  // const storedUserData = sessionStorage.getItem('userData') || '';

 const commonHeaders = {
  headers: {
    // createdBy: storedUserData || '',
    // updatedBy: storedUserData || '',
    createdBy: 1,
    updatedBy: 2,
    userIp: storedHeaders.userIp || '',
    userLat: storedHeaders.userLat || '',
    userLong: storedHeaders.userLong || '',
    deviceSign: storedHeaders.deviceSign || '',
  },
};

const commonHeaders1 = {
  headers: {
    createdBy: 1,
    updatedBy: 2,
  },
}

  const [errors, setErrors] = useState({
    customerName: "",
    address: "",
    city: "",
    pinCode: "",
    gstIn: "",
    contactPerson1: "",
    designation: "",
    mobileNo: "",
    customerPremium: "",
  });


  const [pageSize, setPageSize] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  const [customerId, setCustomerId] = useState("");
  const [customerName, setCustomerName] = useState(""); 
  const [invoiceType, setInvoiceType] = useState("1"); 
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [gstIn, setGstIn] = useState("");
  const [contactPerson1, setContactPerson1] = useState("");
  const [designation, setDesignation] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [customerPremium, setCustomerPremium] = useState("");

  const [allCustomer, setAllCustomer] = useState([]);
  const [updateButton, setUpdateButton] = useState(false);
  const [saveButton, setSaveButton] = useState(true);


  //======Search data from table===============
  const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
  
    const filtered = allCustomer.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? "").toLowerCase().includes(searchValue)
      )
    );
  
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };
  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };


    // Fetch Customer Names
    let isCustomerFetched = false;
    useEffect(() => {
      if (isCustomerFetched) return;
      fetchCustomer();
      isCustomerFetched = true;
    }, []);

  // ==============Get Table Data================

  let isError = false;

  const fetchCustomer = async () => {
    try {
      const response = await axios.get(GetCustomerMaster,commonHeaders1);
      if (response.data !== null) {
        setAllCustomer(response.data);
        setFilteredData(response.data); 
        setTotalEntries(response.data.length);
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Customer:", error);
        toast.error("Failed to fetch Customer data");
        isError = true; 
      }
    }
  };

  // const columns = [
  //   {
  //     title: "Sr.No.",
  //     dataIndex: "",
  //     key: "index",
  //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  //   },
  //   {
  //     title: "Customer Name",
  //     dataIndex: "customerName",
  //     key: "customerName",
  //   },
  //   {
  //     title: "Address",
  //     dataIndex: "address",
  //     key: "address",
  //   },
  //   {
  //     title: "City",
  //     dataIndex: "city",
  //     key: "city",
  //   },
  //   {
  //     title: "Pin Code",
  //     dataIndex: "pinCode",
  //     key: "pinCode",
  //   },
  //   {
  //     title: "GSTIN",
  //     dataIndex: "gstin",
  //     key: "gstin",
  //   },
  //   {
  //     title: "Contact Person1",
  //     dataIndex: "contactPerson1",
  //     key: "contactPerson1",
  //   },
  //   {
  //     title: "Designation",
  //     dataIndex: "designation",
  //     key: "designation",
  //   },
  //   {
  //     title: "MobileNo",
  //     dataIndex: "mobileNo",
  //     key: "mobileNo",
  //   },
  //   {
  //     title: "Customer Premium",
  //     dataIndex: "customerPremium",
  //     key: "customerPremium",
  //   },
  //   {
  //     title: "Actions",
  //     key: "actions",
  //     render: (text, record) => (
  //       <div>
  //         <span
  //           type="submit"
  //           style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
  //           onClick={() => handleEditDataButton(record)}
  //         >
  //           <i class="fa-solid fa-pen-to-square"></i>
  //         </span>
  //         <span
  //           type="submit"
  //           style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
  //           onClick={() => handleDeleteData(record)} 
  //         >
  //           <i class="fa-solid fa-trash"></i>
  //         </span>
  //       </div>
  //     ),
  //   },
  // ];

  const columns = [
  {
    title: "Sr.No.",
    dataIndex: "",
    key: "index",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    key: "customerName",
    sorter: (a, b) => (a.customerName || '').toString().localeCompare((b.customerName || '').toString()),
  },
  // {
  //   title: "Invoice Type",
  //   dataIndex: "invoiceType",
  //   key: "invoiceType",
  //   sorter: (a, b) => (a.invoiceType || '').toString().localeCompare((b.invoiceType || '').toString()),
  // },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
    sorter: (a, b) => (a.address || '').toString().localeCompare((b.address || '').toString()),
  },
  {
    title: "City",
    dataIndex: "city",
    key: "city",
    sorter: (a, b) => (a.city || '').toString().localeCompare((b.city || '').toString()),
  },
  {
    title: "Pin Code",
    dataIndex: "pinCode",
    key: "pinCode",
    sorter: (a, b) => (a.pinCode || '').toString().localeCompare((b.pinCode || '').toString()),
  },
  {
    title: "GSTIN",
    dataIndex: "gstin",
    key: "gstin",
    sorter: (a, b) => (a.gstin || '').toString().localeCompare((b.gstin || '').toString()),
  },
  {
    title: "Contact Person1",
    dataIndex: "contactPerson1",
    key: "contactPerson1",
    sorter: (a, b) => (a.contactPerson1 || '').toString().localeCompare((b.contactPerson1 || '').toString()),
  },
  {
    title: "Designation",
    dataIndex: "designation",
    key: "designation",
    sorter: (a, b) => (a.designation || '').toString().localeCompare((b.designation || '').toString()),
  },
  {
    title: "MobileNo",
    dataIndex: "mobileNo",
    key: "mobileNo",
    sorter: (a, b) => (a.mobileNo || '').toString().localeCompare((b.mobileNo || '').toString()),
  },
  {
    title: "Customer Premium",
    dataIndex: "customerPremium",
    key: "customerPremium",
    sorter: (a, b) => (a.customerPremium || '').toString().localeCompare((b.customerPremium || '').toString()),
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <div>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
          onClick={() => handleEditDataButton(record)}
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </span>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
          onClick={() => handleDeleteData(record)}
        >
          <i className="fa-solid fa-trash"></i>
        </span>
      </div>
    ),
  },
];

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#023E7D",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };


 //=========CANCEL CUSTOMER DATA============
const handleCancel = () => {
  setCustomerName("");
  setInvoiceType("1");
  setAddress("");
  setCity("");
  setPinCode("");
  setGstIn("");
  setContactPerson1("");
  setDesignation("");
  setMobileNo("");
  setCustomerPremium("");

  setUpdateButton(false);
  setSaveButton(true);
  setErrors("");
};

 //=========SAVE CUSTOMER DATA============
    const handleSubmit = async () => {
        let isValid = true;
        const errorObj = {};  
    
        if (!customerName.trim()) {
          isValid = false;
          errorObj.customerName = "Customer Name is required *";
        }
          if(!invoiceType || (typeof invoiceType === 'string' &&!invoiceType.trim())) {
            isValid = false;
            errorObj.dieType = " Die Type is required *";
          }
        if (!address) {
          isValid = false;
          errorObj.address = "Address is required *";
        }
        if (!city) {
          isValid = false;
          errorObj.city = "City is required *";
        }
        if (!pinCode) {
          isValid = false;
          errorObj.pinCode = "Pin Code is required *";
        }
        if (!gstIn) {
          isValid = false;
          errorObj.gstIn = "GSTIN is required *";
        }
        if (!contactPerson1.trim()) {
          isValid = false;
          errorObj.contactPerson1 = "Contact Person is required *";
        }
        if (!designation.trim()) {
          isValid = false;
          errorObj.designation = "Designation is required *";
        }
        if (!mobileNo.trim()) {
          isValid = false;
          errorObj.mobileNo = "Mobile No. is required *";
        }  
        if (!customerPremium.trim()) {
          isValid = false;
          errorObj.customerPremium = "Customer Premium is required *";
        }
       
    
        setErrors(errorObj); // Set error messages
    
        if (!isValid) return;
    
        const saveData = {
            customerName: customerName,
            invoiceType: parseFloat(invoiceType),
            address: address,
            city: city,
            pinCode: parseInt(pinCode),
            gstin: gstIn,
            contactPerson1: contactPerson1,
            designation: designation,
            mobileNo: parseInt(mobileNo),
            customerPremium: parseFloat(customerPremium),
          };       
        
    
        try {
          const response = await axios.post(SaveCustomerMaster, saveData,commonHeaders);
    
          if (response.data === "CREATED") {
            toast.success("Customer added successfully!");
            fetchCustomer();
            handleCancel();
          }
          else if (response.data === "ALREADYEXISTED") {
            toast.warn("Customer already exist!");
            handleCancel();
          }
        } catch (error) {
          console.error("Error during API call:", error);
          toast.error("Error occurred while submitting data");
        }
    };

//=========EDIT CUSTOMER DATA============
const handleEditDataButton = (item) => {
  setUpdateButton(true);
  setSaveButton(false);

  setCustomerId(item.id);
  setCustomerName(item.customerName);
  setInvoiceType(item.invoiceType=== 1 ? "Simplified" : "Detailed");
  setAddress(item.address);
  setCity(item.city);
  setPinCode(item.pinCode);
  setGstIn(item.gstin);
  setContactPerson1(item.contactPerson1);
  setDesignation(item.designation);
  setMobileNo(item.mobileNo);
  setCustomerPremium(item.customerPremium);
};

 //=========UPDATE CUSTOMER DATA============
const handleUpdate = async () => {
  if (
    !customerName || !invoiceType || !address ||  !city || !pinCode || !address || !gstIn || !contactPerson1 || !designation || !mobileNo || !customerPremium ) {
    toast.warn("Please fill all fields!");
    return;
  }

  const invoiceTypeValue = invoiceType === "Simplified" ? 1 : invoiceType === "Detailed" ? 2 : 1;

  const updateData = {
    id: customerId,
    customerName: customerName,
    invoiceType: parseFloat(invoiceTypeValue),
    address: address,
    city: city,
    pinCode: parseInt(pinCode),
    gstin: gstIn,
    contactPerson1: contactPerson1,
    designation: designation,
    mobileNo: parseInt(mobileNo),
    customerPremium:  parseFloat(customerPremium),
  };


  try {
    const response = await axios.put(UpdateCustomerMaster, updateData,commonHeaders);

    if (response.data === "UPDATED") {
      toast.success("Customer updated successfully!");
      fetchCustomer();
      handleCancel();
    }
    else if (response.data === "ALREADYEXISTED") {
      toast.warn("Customer already exist!");
      handleCancel();
    }
  } catch (error) {
    console.error("Error during API call:", error);
    toast.error("Error occurred while updating data");
  }
};

 //=========DELETE CUSTOMER DATA============
const handleDeleteData = async (item) => {
  const confirmDelete = window.confirm(
    `Are you sure you want to delete the Customer "${item.customerName}"?`
  );
  if (!confirmDelete) return;

  try {
    const response = await axios.delete(`${DeleteCustomerMaster}?id=${item.id}`,commonHeaders1);
    if (response.data === "DELETED") {
      toast.success("Customer deleted successfully!");
      fetchCustomer();
      handleCancel();
    }
  } catch (error) {
    console.error("Error during delete operation:", error);
    toast.error("Error occurred while deleting the Customer");
  }
};

  return (
    <>
      <div className="px-5 py-3">
        <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          <div className="col-12">

            <div className="row px-md-5 mt-3 p-2" >
                  <div className="col-12 col-lg-2"></div>
                  <div className="col-12 col-lg-8">
                      <div className="row p-0 m-0">

                        <div className="col-lg-8 py-1">
                              <label className="labels">Customer Name</label>
                              <Input maxLength={250}
                                value={customerName}
                                onChange={(e) => setCustomerName(e.target.value)}
                                placeholder="Enter Name"
                              />
                              {errors.customerName && (
                                <div className="errorField">{errors.customerName}</div>
                              )}
                        </div>
                        
                        <div className="col-lg-4 py-1">
                              <label className="labels">GSTIN</label>
                              <Input
                                value={gstIn} maxLength={250}
                                onChange={(e) => setGstIn(e.target.value)}
                                placeholder="Enter Code"
                              />
                              {errors.gstIn && (
                                <div className="errorField">{errors.gstIn}</div>
                              )}
                        </div>

                        <div className="col-lg-8 py-1">
                            <label className="labels">Address</label>
                            <Input.TextArea
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                              placeholder="Enter Address"
                              maxLength={250} // You can adjust this limit as needed
                            />
                            {errors.address && <div className="errorField">{errors.address}</div>}
                        </div> 
                        <div className="col-lg-4 py-1"></div>

                        <div className="col-lg-5 py-1">
                              <label className="labels">City</label>
                              <Input maxLength={250}
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                                placeholder="Enter Name"
                              />
                              {errors.city && (
                                <div className="errorField">{errors.city}</div>
                              )}
                        </div>

                        <div className="col-lg-3 py-1">
                              <label className="labels">PinCode</label>
                              <Input   maxLength={6}
                                value={pinCode}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d{0,10}$/.test(value)) setPinCode(value); // only allow up to 10 digits
                                }}
                                placeholder="Enter Code"
                              />
                              {errors.pinCode && (
                                <div className="errorField">{errors.pinCode}</div>
                              )}
                        </div>
                        <div className="col-lg-4 py-1"></div>

                        <div className="col-lg-5 py-1">
                              <label className="labels">Contact Person</label>
                              <Input   maxLength={250}
                                value={contactPerson1}
                                onChange={(e) => setContactPerson1(e.target.value)}
                                placeholder="Enter Name"
                              />
                              {errors.contactPerson1 && (
                                <div className="errorField">{errors.contactPerson1}</div>
                              )}
                        </div>

                        <div className="col-lg-4 py-1">
                              <label className="labels">Designation</label>
                              <Input
                                value={designation}
                                onChange={(e) => setDesignation(e.target.value)}
                                placeholder="Enter Code"
                              />
                              {errors.designation && (
                                <div className="errorField">{errors.designation}</div>
                              )}
                        </div>

                        <div className="col-lg-3 py-1">
                              <label className="labels">Mobile No.</label>
                              <Input
                                  value={mobileNo}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,10}$/.test(value)) setMobileNo(value); // only allow up to 10 digits
                                  }}
                                  placeholder="Enter Mobile Number"
                                  maxLength={10}
                                />
                                {errors.mobileNo && (
                                  <div className="errorField">{errors.mobileNo}</div>
                                )}
                        </div>

                        <div className="col-lg-5 py-1">
                              <label className="labels">Customer Premium</label>
                              <Input type="number"
                                value={customerPremium}
                                onChange={(e) => setCustomerPremium(e.target.value)}
                                placeholder="Enter Premium"
                              />
                              {errors.customerPremium && (
                                <div className="errorField">{errors.customerPremium}</div>
                              )}
                        </div> 

                        <div className="col-lg-5 mb-3">
                          <label className="labels">Invoice Type</label>
                          <Select
                            value={invoiceType || undefined}
                            onChange={(value) => setInvoiceType(value)}
                            placeholder="Enter Type of Invoice"
                            style={{ width: '100%' }}
                            showSearch
                                      optionFilterProp="children"
                          >
                            <Option value="1">Simplified</Option>
                            <Option value="2">Detailed</Option>
                          </Select>
                          {errors.invoiceType && <div className="errorField">{errors.invoiceType}</div>}
                        </div>                         

                      </div>  
                  </div>
                  <div className="col-12 col-lg-2"></div>
                    <div className="col-12 text-center pt-3">
                      <Button
                        type="submit"
                        className="CancelBtn mx-1"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                      {saveButton && (
                      <Button
                        type="submit"
                        className="SubmitBtn mx-1"
                        onClick={handleSubmit}
                      >
                        Submit
                      </Button>
                      )}
                      {updateButton && (
                        <Button
                          type="submit"
                          className="UpdateBtn mx-1"
                          onClick={handleUpdate}
                        >
                          Update
                        </Button>
                      )}
                    </div>

              <div  className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid rgb(207, 207, 207)" }}></div>
            </div>

            {/*================ Table =========================*/}
            <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">
              <div
                className="col-12 py-3 shadow border"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="col-12 px-md-5"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                    <Select
                      defaultValue={pageSize}
                      onChange={handlePageSizeChange}
                      style={{ width: 120, textAlign: "center" }}
                    >
                      <Option value={10}>10</Option>
                      <Option value={20}>20</Option>
                      <Option value={30}>30</Option>
                    </Select>
                  </div>

                  <div className="pt-4 pt-md-0">
                    <Input.Search
                      placeholder="Search"
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{ width: 200, marginBottom: 16 }}
                    />
                  </div>
                </div>

                <div style={{ backgroundColor: "white" }}>
                  <Table
                    bordered
                    style={{ padding: "0px 20px", overflowX: "auto" }}
                    columns={columns}
                    dataSource={filteredData}
                    pagination={{
                      pageSize: pageSize,
                      total: totalEntries,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      current: currentPage,
                      onChange: (page) => setCurrentPage(page),
                    }}
                    showSorterTooltip={false}
                    rowKey={(record) => record.id}
                    components={components}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
   </>
  )
}

export default CustomerMaster